import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppBarActionsService, AppBarTitleService, SimpleDialogService, CommonActionKey, LoanDocumentService, MessageService, parseNumber, AppBarAction, SignedLoanDocumentFile } from 'common';
import { UserPermissionId, readWrite } from '../../user/user-permission/user-permission.data';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';

@UntilDestroy()
@Component({
    selector: 'ifb-account-document-details',
    templateUrl: './account-document-details.component.html',
    styleUrls: ['./account-document-details.component.scss'],
    standalone: false
})
export class AccountDocumentDetailsComponent implements OnInit {
  loanId: number;
  documentFile: SignedLoanDocumentFile;
  readWrite: boolean = false;
  userPermissionId: UserPermissionId = "servicing-account-documents";

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly appBarTitleService: AppBarTitleService,
    private readonly appBarActionsService: AppBarActionsService,
    private readonly documentService: LoanDocumentService,
    private readonly userPermissionService: UserPermissionService,
    private readonly messageService: MessageService,
    private readonly simpleDialogService: SimpleDialogService
  ) {
    this.appBarActionsService.actions = [
      { id: 'cancel', label: 'Cancel', buttonType: 'button'  },
      { id: 'download', label: 'download', buttonType: 'icon', icon: 'get_app' },
      { id: 'delete', label: 'delete', buttonType: 'icon', icon: 'delete'}
    ];
    this.loanId = parseNumber(this.route.snapshot.params.id);
  }

  ngOnInit(): void {
    this.dataInit();
  }

  actionDispatch(action: AppBarAction): void {
    const actionHandler: (action: AppBarAction) => void = this[action.id].bind(this);
    actionHandler(action);
  }

  delete(): void {
    if(!this.readWrite) {
      this.messageService.error("You don't have permissions to delete this file");
      return;
    }
    this.simpleDialogService.openSimpleConfirmDialog(`Delete file ${this.documentFile.filename}?`, 'Confirm')
      .subscribe((result: CommonActionKey) => {
        if(result === CommonActionKey.Confirm) {
          this.documentService.delete(this.documentFile.id, null)
            .subscribe(()=> {
              this.navigateBack();
            });
        }
      });
  }

  download(): void {
    this.documentService.download(this.documentFile.id, this.loanId);
  }

  cancel(): void {
    this.navigateBack();
  }

  private dataInit(): void {
  this.route.data.pipe(untilDestroyed(this)).subscribe((data: any) => {
      this.appBarTitleService.title = data.documentFile.filename;
      this.documentFile = data.documentFile;
      this.appBarActionsService.actions.find(x=>x.id == 'delete').hidden = !this.documentFile.canDelete;
      this.userPermissionService.granted([readWrite(this.userPermissionId)])
      .subscribe(res => {
        this.readWrite = res
      });
    });

    this.appBarActionsService.invoking.pipe(untilDestroyed(this))
    .subscribe(this.actionDispatch.bind(this));
  }

  private navigateBack(): void {
    this.router.navigate([`account/${this.loanId}/documents`]);
  }
}
